import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgCreateFlowsUrl from '@/assets/misc/img_create-flows.svg'
import TeamRolesIllustration from '@/components/SpotIllustration/TeamRolesIllustration'

export interface MergeAccountsDialogProps {
  showing: boolean
  onClose: () => unknown
  onLink: () => unknown
  isLinkPending: boolean
  displayName: string
}

export function MergeAccountsDialog({
  showing,
  onClose,
  onLink,
  isLinkPending,
  displayName,
}: MergeAccountsDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isLinkPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={imgCreateFlowsUrl}
            illustration={byDesign(undefined, TeamRolesIllustration)}
            alt="Hands holding cards with checkboxes"
          />
          <ModalSheetContentTitle>
            You're about to merge accounts
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Ensure that you have obtained valid certification from{' '}
            <strong>{displayName}</strong>. Once merged, this action cannot be
            undone.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button label="Close" isDisabled={isLinkPending} onPress={onClose} />
          <Button
            label="Confirm Merge"
            isDisabled={isLinkPending}
            variant="primary"
            onPress={onLink}
            isPending={isLinkPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
